import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Comment Begin
// This code below I copied from https://github.com/vuematerial/vue-material/issues/1977
// Because vue router version >= 3.0.2 was causing MdRouterLinkProps to fail
Vue.component('router-link', Vue.options.components.RouterLink)
Vue.component('router-view', Vue.options.components.RouterView)
// Comment End

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/Authentication.vue'),
      children: [
        { path: '/', component: () => import('@/pages/authPages/login.vue') },
        { path: '/login', component: () => import('@/pages/authPages/login.vue') }
      ]
    },
    {
      path: '/app',
      component: () => import('@/layouts/MainLayout.vue'),
      children: [
        { path: '', component: () => import('@/pages/appPages/main.vue') },
        { path: '/incidence-report', component: () => import('@/pages/appPages/incidenceReport.vue') },
        { path: '/driver-shift', component: () => import('@/pages/appPages/driverShifts.vue') },
        { path: '/staff', component: () => import('@/pages/appPages/users.vue') }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js